"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEditablePages = useEditablePages;
const SnackbarHelper_1 = require("@juvare/common-web-ui/SnackbarHelper");
const hooks_1 = require("../../../../ui/hooks");
const react_1 = __importDefault(require("react"));
function useEditablePages(appName, baseUrl) {
    const publicDataClient = (0, hooks_1.usePublicDataClient)(appName, baseUrl);
    const [editablePages, setEditablePages] = react_1.default.useState();
    react_1.default.useEffect(() => {
        publicDataClient
            .publicDataGetObject('editable-pages')
            .then((response) => {
            setEditablePages(response);
        })
            .catch((error) => {
            (0, SnackbarHelper_1.handleErrorSnackbar)(error);
            setEditablePages([]);
        });
    }, [publicDataClient]);
    return editablePages;
}
